module.exports = __webpack_public_path__ + "static/img/servicio.f5827fd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/servicio.jpg
// module id = Iqtf
// module chunks = 47